import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null },
  { prop: 'rfid', label: 'RFID', width: null },
  { prop:'repairFactory',label:"维修工厂", width:null},
  { prop: 'strScanTime', label: '扫描时间', width: null },
  { prop: 'state', label: '状态', width: null },
  { prop: 'strTip', label: '提示/警告信息', width: null },
];
export default { tableHeader }
